// fade relevant buttons depending on state
// import ref from './_state';

export default function (ref) {

    if (ref.activeIndex === 0) {
        ref.dom.select('#js-prev').style('opacity', 0.2); 
        ref.dom.select('#js-next').style('opacity', 1);
    } else if(ref.activeIndex === ref.uniNames.length-1) {
        ref.dom.select('#js-next').style('opacity', 0.2); 
        ref.dom.select('#js-prev').style('opacity', 1);
    } else {
        ref.dom.select('#js-prev').style('opacity', 1); 
        ref.dom.select('#js-next').style('opacity', 1); 
    }

    // set fade on salary btn, as it's first chart to be rendered
    ref.dom.selectAll('.js-btn-chart').transition().style('opacity', 1).style('pointer-events', 'auto');
    ref.dom.select('#js-btn-salary').transition().style('opacity', 0.4).style('pointer-events', 'none'); 

}